<div [ngClass]="{'right':isRight} " id="menuToggle">
	<span [style.background-color]="color "></span>
	<span [style.background-color]="color "></span>
	<span [style.background-color]="color "></span>
</div>